import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { isNullOrUndefined } from 'util';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
    providedIn : 'root'
})
export class ExcelService {
constructor() { }
  public exportAsExcelFile(json: any[], excelFileName: string, footer ?:any[]): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    // Make Header Uppercase
    var range = XLSX.utils.decode_range(worksheet['!ref']);
    for(var C = range.s.r; C <= range.e.r; ++C) {
      var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
      if(!worksheet[address]) continue;
      worksheet[address].v = worksheet[address].v.toUpperCase();
      worksheet[address].v = worksheet[address].v.replace(/_/g, " ");
    }
    //End of making header uppercase
    //Adjust Width
     worksheet['!cols'] = this.formatExcelCols(json)
    //End of Adjust Width

    //add footer row
    if(!isNullOrUndefined(footer)){
      let getHeaders = Object.keys(footer[0]).map(e => e.replace(/_/g, " "))
      getHeaders = getHeaders.map(v => v.toUpperCase())
      XLSX.utils.sheet_add_aoa(worksheet, [], { origin : -1} )
      XLSX.utils.sheet_add_aoa(worksheet, [ getHeaders ], { origin : -1} )
      XLSX.utils.sheet_add_json(worksheet, footer, {skipHeader : true, origin : -1})

    }
    //end of add footer row

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    FileSaver.saveAs(data, fileName + '_report_' + new  Date().getTime() + EXCEL_EXTENSION);
  }



  public exportTableAsExcelFile(element : HTMLElement, filename){
    /* table id is passed over here */    
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename + EXCEL_EXTENSION);
  }


   formatExcelCols(json) {
    let widthArr = Object.keys(json[0]).map(key => {
        return { width: key.length + 2 } // plus 2 to account for short object keys
    })
    for (let i = 0; i < json.length; i++) {
        let value :  any[] = Object.values(json[i]);
        for (let j = 0; j < value.length; j++) {
            if (value[j] !== null && String(value[j]).length > widthArr[j].width) {
                widthArr[j].width = String(value[j]).length+10;
            }
        }
      }
      return widthArr
  }


  public convertExcelFileToJsonArray(data: any) : any[]{
    let workbook = XLSX.read(data, {
      type: 'binary'
    })
    const headers = this.generateCamelCaseHeaders(workbook)
    let jsonObjs = workbook.SheetNames.map(sheet => {
      let rowObject = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {header : headers, range : 1})
      return rowObject
    })

    return jsonObjs;
  }

    formatColumnName(name : string){
      return name.trim().toLowerCase().replace(/_/g, " ").replace(/\s+/g, ' ').replace(/\s(.)/g, function($$,$1) { return $1.toUpperCase()})
    }



    generateCamelCaseHeaders(workbook : XLSX.WorkBook){
      let worksheet = workbook.SheetNames.map(sheet => workbook.Sheets[sheet])[0]
      let range = XLSX.utils.decode_range(worksheet['!ref'])
      var headers = [];
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var address = XLSX.utils.encode_cell({r:range.s.r, c:C}); // <-- first row, column number C
        if(!worksheet[address]) continue;
        headers.push(this.formatColumnName( worksheet[address].v));
      }
      return headers;
    }

    exportAsExcelFileV2(json: any[], excelFileName: string, footer ?:any[]): void {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      worksheet['!cols'] = this.formatExcelCols(json)
      if(!isNullOrUndefined(footer)){
        let getHeaders = Object.keys(footer[0]).map(e => e.replace(/_/g, " "))
        getHeaders = getHeaders.map(v => v.toUpperCase())
        XLSX.utils.sheet_add_aoa(worksheet, [], { origin : -1} )
        XLSX.utils.sheet_add_aoa(worksheet, [ getHeaders ], { origin : -1} )
        XLSX.utils.sheet_add_json(worksheet, footer, {skipHeader : true, origin : -1})
  
      }
      const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, excelFileName);



  

    }


  }

